import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

/**
 * Scrolls the window to the top of the page when route pathname changes
 */
export function useScrollToTop(): void {
  const {pathname} = useLocation();

  useEffect(() => {
    const canControlScrollRestoration = 'scrollRestoration' in window.history;
    if (canControlScrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
  }, [pathname]);
}
